import React, {PropTypes} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Screen from './Screen';
import * as screenActions from '../actions/screenAction';

class App extends React.Component {
    render() {
        return (
                    <Screen 
                        name={this.props.data.name} 
                        textResources={this.props.data.textResources} 
                        uiSpec={this.props.data.uiSpec} 
                        values={this.props.data.values} 
                        additionalScreens={this.props.additionalScreens}/>
        );
    }
}

App.propTypes = {
    data: React.PropTypes.object,
    additionalScreens: React.PropTypes.object
};

function mapStateToProps(state) {
    return {        
        data: state.screen
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(screenActions, dispatch)
    };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);


/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/